import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, Button, Modal, Row, Col } from 'antd'

import { requestChangePassword } from 'redux/Admin/actions'

import FormPasswordReset from 'components/Settings/ModalPassword'

class SettingsAccount extends React.Component {
    state = {
        passwordModalVisible: false
    }

    showModalPassword = () => {
        this.setState({
            passwordModalVisible: true
        })
    }

    handleCancel = () => {
        this.setState({
            passwordModalVisible: false
        })
    }

    changePassword = values => {
        this.props.requestChangePassword({
            oldPass: values.old,
            newPass: values.password
        })
    }

    render() {
        const { loadingPasswordChange } = this.props

        return (
            <Row justify="center" type="flex">
                <Col xs={24} md={18} lg={12}>
                    <Card title="Account">
                        <Row justify="space-between" type="flex">
                            <Col style={{ display: 'flex', alignItems: 'center' }}>Password</Col>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button onClick={this.showModalPassword} style={{ margin: 0 }} type="primary">
                                    Change Password
                                </Button>
                            </Col>
                        </Row>
                        <Modal
                            title="Change Password"
                            visible={this.state.passwordModalVisible}
                            footer={null}
                            onCancel={this.handleCancel}
                        >
                            <FormPasswordReset onSubmit={this.changePassword} loadingAnswer={loadingPasswordChange} />
                        </Modal>
                    </Card>
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = ({ admin }) => ({
    loadingPasswordChange: admin.loading.changePassword
})

const mapActionsToProps = dispatch => ({
    requestChangePassword: bindActionCreators(requestChangePassword, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(SettingsAccount)
